import { render } from "./FaqFooter.vue?vue&type=template&id=8ba95c58&scoped=true"
import script from "./FaqFooter.vue?vue&type=script&lang=js"
export * from "./FaqFooter.vue?vue&type=script&lang=js"

import "./FaqFooter.vue?vue&type=style&index=0&id=8ba95c58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ba95c58"]])

export default __exports__